import { createContext, useContext } from 'react';

/**
 * Posto nel menu laterale del CRM dove la pagina Impostazioni mette il proprio menu.
 * Il Layout lo crea quando si e' su /settings; SettingsLayout ci disegna dentro con un portal.
 */
export interface SettingsSidebarSlot {
  element: HTMLElement | null;
  collapsed: boolean;
}

export const SettingsSidebarSlotContext = createContext<SettingsSidebarSlot>({ element: null, collapsed: false });

export const useSettingsSidebarSlot = () => useContext(SettingsSidebarSlotContext);
